/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type LineOaShopConnectionConfig = {
    id?: string;
    createdAt?: string;
    updatedAt?: string;
    shopId?: string;
    channelAccessToken?: string;
    richMenuId?: string;
    contactInfoType?: LineOaShopConnectionConfig.contactInfoType;
    contactInfo?: string;
    enabled?: boolean;
    webhookUrlPath?: string;
};
export namespace LineOaShopConnectionConfig {
    export enum contactInfoType {
        CUSTOM_LINK = 'CUSTOM_LINK',
        LINE_OA_CHAT = 'LINE_OA_CHAT',
    }
}

